import { connect } from "react-redux";
import Waste from "./Waste";

const mapStoreStateToProps = (store: any) => ({
  sites: store.siteReducer.sites,
  groups: store.groupReducer.groups,
});

export default connect(mapStoreStateToProps)(Waste);
